import { render, staticRenderFns } from "./Design-List.vue?vue&type=template&id=2b427ac2&scoped=true&"
import script from "./Design-List.vue?vue&type=script&lang=js&"
export * from "./Design-List.vue?vue&type=script&lang=js&"
import style0 from "./Design-List.vue?vue&type=style&index=0&id=2b427ac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b427ac2",
  null
  
)

export default component.exports